export function setLocalStorage(key: string, value: string) {
	localStorage.setItem(key, value)
}

export function getLocalStorage(key: string) {
	return localStorage.getItem(key)
}

export function removeLocalStorage(key: string) {
	return localStorage.removeItem(key)
}

// 把 safe 模块的容错读取函数挂到统一 barrel 上,业务侧只 import '@src/utils/storage' 即可
export { getLocalStorageSafe, getLocalStorageBoolean } from './safe'
